module.exports = __webpack_public_path__ + "img/home_p4_icon1.0f7a588b.png";